<template>
  <div>
    <div class="col-md-10 pl-0">
      <div
        class="card card-box"
        style="border-radius : 0%; height: 100%;  min-height: 650px;"
      >
        <div class="card-body">
          <b-form>
            <div class="row">
              <div class="col-md-12 mt-2 mb-3">
                <h4 class="__blue" style="font-weight: 700">
                  Bridging BPJS
                </h4>
              </div>
              <div class="col-md-12">
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="Username PCare:"
                  label-for="input-horizontal"
                >
                  <b-form-input
                    id="input-horizontal"
                    :disabled="btnDisable"
                    placeholder="Tulis Username PCare"
                    v-model="form.pcare_username"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="Password PCare:"
                  label-for="input-horizontal"
                >
                  <b-form-input
                    id="input-horizontal"
                    :disabled="btnDisable"
                    placeholder="Tulis Password PCare"
                    v-model="form.pcare_password"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="Kode PPK:"
                  label-for="input-horizontal"
                >
                  <b-form-input
                    id="input-horizontal"
                    :disabled="btnDisable"
                    placeholder="Tulis Kode PPK"
                    v-model="form.kdprovider"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="ConsID:"
                  label-for="input-horizontal"
                >
                  <b-form-input
                    id="input-horizontal"
                    :disabled="btnDisable"
                    placeholder="Tulis Cons ID"
                    v-model="form.cons_id"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="Secret Key PCare:"
                  label-for="input-horizontal"
                >
                  <b-form-input
                    id="input-horizontal"
                    :disabled="btnDisable"
                    placeholder="Tulis Secret Key PCare"
                    v-model="form.cons_secret"
                  ></b-form-input>
                </b-form-group>
                <!-- <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="Kode Aplikasi:"
                  label-for="input-horizontal"
                >
                  <b-form-input
                    id="input-horizontal"
                    :disabled="btnDisable"
                    placeholder="Tulis Kode Aplikasi"
                    v-model="form.kdaplikasi"
                  ></b-form-input>
                </b-form-group> -->
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="User Key PCare:"
                  label-for="input-horizontal"
                >
                  <b-form-input
                    id="input-horizontal"
                    :disabled="btnDisable"
                    placeholder="Tulis User Key PCare"
                    v-model="form.user_key"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="fieldset-user-key-fktp"
                  label-cols-sm="4"
                  label-cols-lg="4"
                  content-cols-sm
                  content-cols-lg="8"
                  label="User Key Antrean Online:"
                  label-for="input-user-key-fktp"
                >
                  <b-form-input
                    id="input-user-key-fktp"
                    :disabled="btnDisable"
                    placeholder="Tulis User Key Antrean Online"
                    v-model="form.user_key_fktp"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-alert show variant="dark" class="alert-bridging-bpjs">
                  <p>Prosedur Bridging BPJS:</p>
                  <div class="p-bridging-bpjs d-flex">
                    <span style="margin-right: 5px;">-</span>Pihak Fasilitas
                    Kesehatan koordinasi dengan kantor cabang BPJS setempat
                    untuk melakukan bridging BPJS
                  </div>
                  <p class="p-bridging-bpjs d-flex">
                    <span style="margin-right: 5px;">-</span> Pihak Fasilitas
                    Kesehatan memenuhi syarat dan ketentuan untuk melakukan
                    bridging BPJS
                  </p>
                  <p class="p-bridging-bpjs d-flex">
                    <span style="margin-right: 5px;">-</span>Pihak Fasilitas
                    Kesehatan mendapatkan cons ID - Secret Key
                  </p>
                  <p class="p-bridging-bpjs d-flex">
                    <span style="margin-right: 5px;">-</span>Pihak Fasilitas
                    Kesehatan mengisi cons ID - Secret Key di profil izidok
                  </p>
                </b-alert>
              </div>
              <div class="col-md-12 mt-5 mb-3">
                <b-button
                  variant="primary"
                  v-if="!btnDisable"
                  class="float-right"
                  @click="onSubmit"
                  >SIMPAN</b-button
                >
                <b-button
                  variant="primary"
                  v-if="btnDisable"
                  @click="btnDisable = false"
                  class="float-right"
                  >EDIT DATA</b-button
                >
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </div>
    <b-modal
      ref="__modal_loading"
      hide-header
      hide-footer
      no-close-on-esc
      centered
      no-close-on-backdrop
      content-class="shadow-none modal_loading"
      size="xs"
    >
      <b-row>
        <b-col sm="12" class="text-center">
          <div class="spinner-border text-warning mb-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p>
            Mohon Menunggu <br />
            Sedang melakukan proses konfigurasi
          </p>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data: () => {
    return {
      status: false,
      btnDisable: true,
      form: {
        pcare_username: null,
        pcare_password: null,
        kdprovider: null,
        cons_id: null,
        cons_secret: null,
        kdaplikasi: '095',
        user_key: null,
        user_key_fktp: null
      }
    };
  },
  mounted() {
    this.fetchData();

    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  methods: {
    onSubmit() {
      this.$swal
        .fire({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Apakah Anda yakin akan <br> melakukan Bridging BPJS?</p>',
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#1791EE",
        })
        .then(res => {
          if (res.value) {
            this.btnDisable = true;
            this.submit();
          }
        });
    },
    async submit() {
      // this.$refs["__modal_loading"].show();
      const res = await this.$axios.put(
        `bpjs/auth?klinik_id=${this.getKlinikId}`,
        this.form
      );
      const { status, status_bridging_antrol } = res.data;
      // this.$refs["__modal_loading"].hide();
      // console.log(res.data);
      if (status) {
        this.$store.commit("SET_BPJS_AUTH_VALID", true);
        this.$store.commit("SET_BRIDGING_ANTREAN_FKTP", status_bridging_antrol);
        if (status_bridging_antrol === false) {
          this.$swal({
            type: "success",
            title: "Bridging BPJS berhasil!",
            html: `
              <div>
                  <p class="text-left pl-4" style="font-size: 16px;">Catatan: </p>
                  <p class="text-danger text-left pl-4" style="font-size: 14px;line-height: 17px;">
                    Bridging antrian online gagal.<br>Silakan cek kembali data konfigurasi atau hubungi PIC kantor cabang BPJS Anda!
                  </p>
              </div>`,
            showCancelButton: true,
            cancelButtonText: "Lanjutkan",
            confirmButtonText: "Batal",
            cancelButtonColor: "#1bc943",
            confirmButtonColor: "red",
            allowOutsideClick: false
          }).then(res => {
            if (res.value) {
              this.btnDisable = false;
              this.$swal.close();
            } else {
              this.btnDisable = true;
              this.form = {
                ...this.form,
                user_key_fktp: null
              };
            }
          });
        } else {
          this.$swal({
            type: "success",
            html:
              '<p class="m-0 text-bridging-bpjs">Bridging BPJS berhasil!</p>'
          });
        }

        // const resKhusus = await this.$axios.get(`bpjs/referensi-khusus?klinik_id=${this.getKlinikId}`);
        // const khusus = resKhusus.data;
        // if (khusus) {
        //   if (khusus.response.list.length > 0) {
        //     this.$store.commit("SET_BPJS_AUTH_VALID", 0);
        //     this.$swal({
        //       type: "success",
        //       html: '<p class="m-0 text-bridging-bpjs">Bridging BPJS berhasil!</p>',
        //     });
        //   } else {
        //     this.btnDisable = false;
        //     this.$swal({
        //       type: "error",
        //       html: '<p class="m-0 text-bridging-bpjs">Bridging BPJS gagal! <br> Mohon cek kembali data konfigurasi atau hubungi PIC kantor cabang BPJS Anda!</p>',
        //     });
        //   }
        // }
      } else {
        this.btnDisable = false;
        this.$swal({
          type: "error",
          html:
            '<p class="m-0 text-bridging-bpjs">Bridging BPJS gagal! <br> Mohon cek kembali data konfigurasi atau hubungi PIC kantor cabang BPJS Anda!</p>'
        });
      }
    },
    async fetchData() {
      try {
        const res = await this.$axios.get(
          `bpjs/auth?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          if (data.bpjs_auth_valid) {
            this.form = {
              pcare_username: data.bpjs_pcare_username,
              pcare_password: data.bpjs_pcare_password,
              kdprovider: data.bpjs_kdprovider,
              cons_id: data.bpjs_cons_id,
              cons_secret: data.bpjs_cons_secret,
              kdaplikasi: data.bpjs_kdaplikasi,
              user_key: data.bpjs_user_key
            };
          }

          if (data.bpjs_config.length > 0) {
            const mapping = {
              wsbpjs_user_key: "user_key_fktp"
              // antrean_fktp_password: "fktp_password",
              // antrean_fktp_user_key: "fktp_user_key"
            };

            data.bpjs_config.forEach(config => {
              const key = mapping[config.key];
              if (key) {
                this.form[key] = config.value;
              }
            });
          }

          this.status = true;
        }
      } catch (e) {}
    }
  }
};
</script>

<style>
.col-form-label {
  margin-bottom: 20px;
}
.text-bridging-bpjs {
  font-size: 14px;
}
.modal_loading .modal-header {
  background-color: #ffffff;
}
.modal-backdrop {
  opacity: 0.5 !important;
}
</style>

<style scoped>
.__blue {
  color: #4b80b6;
}
.alert {
  border-radius: 5px;
}
.alert-radio-label {
  padding: 0.75rem 2rem;
  margin-right: 50px;
}
.alert-bridging-bpjs {
  background-color: #eeeff8;
  opacity: 1;
  top: -10px;
}
.p-bridging-bpjs {
  margin: 0;
}
.spinner-border {
  width: 5em;
  height: 5em;
}
</style>
